<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_4578_1606" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
<rect width="20" height="20" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_4578_1606)">
<path d="M9.99996 17.1951L6.52246 13.7176L7.42621 12.8138L9.99996 15.3876L12.5737 12.8138L13.4775 13.7176L9.99996 17.1951ZM7.42621 7.23672L6.52246 6.33297L9.99996 2.85547L13.4775 6.33297L12.5737 7.23672L9.99996 4.66297L7.42621 7.23672Z" fill="currentColor"/>
</g>
</svg>
